import http from "@/settings/apiSettings";

class RU_RegesDataService {
  getConfig(): Promise<any> {
    return http.clientResurseUmane.get("/ru/reges/config");
  }
  saveConfig(data: any): Promise<any> {
    return http.clientResurseUmane.put("/ru/reges/config", data);
  }
  getMesaje(params: { status?: string | null; dataStart?: string | null; dataEnd?: string | null }): Promise<any> {
    return http.clientResurseUmane.get("/ru/reges/mesaje", { params });
  }
  trimiteContract(contractId: string, operatie = "AdaugareContract"): Promise<any> {
    return http.clientResurseUmane.post(`/ru/reges/trimite-contract/${contractId}`, null, { params: { operatie } });
  }
  retrimite(mesajId: string): Promise<any> {
    return http.clientResurseUmane.post(`/ru/reges/retrimite/${mesajId}`);
  }
  proceseazaStatus(): Promise<any> {
    return http.clientResurseUmane.post("/ru/reges/proceseaza-status");
  }
}

export default new RU_RegesDataService();
